"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_Instagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "F4ABF144-D028-49CB-BBA6-026846943F11"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "57.698095%",
    y1: "-5.02086682%",
    x2: "85.3992879%",
    y2: "114.27958%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913BAF",
    offset: "14.8736013%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D52D88",
    offset: "31.5836243%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D72E85",
    offset: "49.3765337%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6366D",
    offset: "81.6509905%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26D4F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.375,1.89478063e-15 C29,1.89478063e-15 32,3 32,7.625 L32,24.375 C32,29 29,32 24.375,32 L7.625,32 C3,32 0,29 0,24.375 L0,7.625 C0,3 3,1.89478063e-15 7.625,1.89478063e-15 L24.375,1.89478063e-15 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "52.7221771%",
    cy: "67.4067586%",
    fx: "52.7221771%",
    fy: "67.4067586%",
    r: "64.5047159%",
    gradientTransform: "translate(0.527222,0.674068),rotate(15.557288),scale(1.000000,0.941692),translate(-0.527222,-0.674068)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED980",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCAE49",
    offset: "37.2276316%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06745",
    offset: "55.5546347%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E83D5C",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 21.4375,
    height: 21.3125,
    rx: 6.3984375
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.7%",
    y: "-12.8%",
    width: "125.5%",
    height: "125.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.23046875,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.23046875,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.130632926 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-7",
    cx: 10.75,
    cy: 10.75,
    r: 5.125
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-26.6%",
    y: "-26.6%",
    width: "153.3%",
    height: "153.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.23046875,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.23046875,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.130632926 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 17.03125,
    cy: 4.375,
    r: 1.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50.0%",
    y: "-50.0%",
    width: "200.0%",
    height: "200.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.130632926 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-79.000000, -398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-/-Instagram-/-App-Launcher",
    transform: "translate(79.000000, 398.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.375,1.89478063e-15 C29,1.89478063e-15 32,3 32,7.625 L32,24.375 C32,29 29,32 24.375,32 L7.625,32 C3,32 0,29 0,24.375 L0,7.625 C0,3 3,1.89478063e-15 7.625,1.89478063e-15 L24.375,1.89478063e-15 Z",
    id: "Background",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Yellow-Flare"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625,46.8125 C22.1171747,46.8125 32.21875,36.7109247 32.21875,24.25 C32.21875,11.7890753 22.1171747,1.6875 9.65625,1.6875 C-2.80467467,1.6875 -12.90625,11.7890753 -12.90625,24.25 C-12.90625,36.7109247 -2.80467467,46.8125 9.65625,46.8125 Z",
    id: "Oval-3",
    fill: "url(#radialGradient-4)",
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.312500, 5.437500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera-Frame"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFFFFF",
    strokeWidth: 2.4609375,
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFFFFF",
    strokeWidth: 2.4609375,
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }))))))));
}

var _default = ic_Instagram;
exports.default = _default;